import z from "zod";

export const getCalculationServiceParamSchema = z.object({
	calculationId: z.uuid(),
	serviceCalculationItemId: z.uuid(),
});

export type GetCalculationServiceParamSchema = z.infer<typeof getCalculationServiceParamSchema>;
